import React, { useEffect } from "react";

//constants
import { IDelegationManagementStepTwoProps } from "./module/constants";
import { DELEGATION_MANAGEMENT_URLS } from "../module/constants";
import { ROUTES } from "../../../module/constants";

//components
import RolesList from "../../../components/RolesList/RolesList";
import OutlinedButton from "../../../ui/OutlinedButton/OutlinedButton";
import { FormattedMessage } from "react-intl";

//selectors and actions
import { selectSelectedRole } from "../module/selectors";
import {
  modifySelectedRole,
  modifySelectedUsersDelegation,
} from "../module/actions";
import { selectUserInfo } from "../../../App/module/selectors";

//utils
import { push } from "connected-react-router";
import { connect } from "react-redux";
import messages from "./module/messages";
import { createStructuredSelector } from "reselect";

//styles
import classes from "./DelegationManagementStepTwo.module.scss";

const DelegationManagementStepTwo = (
  props: IDelegationManagementStepTwoProps
) => {
  const {
    userInfo,
    selectedRole,
    modifySelectedUsersDelegation,
    modifySelectedRole,
    changeLocation,
  } = props;

  useEffect(() => {
    modifySelectedUsersDelegation([]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRole]);

  const createRoleArray = () => {
    let roleArray: any[] = [];
    userInfo.roles.basicRoles.map(
      // eslint-disable-next-line array-callback-return
      (singleRole: { roleName: any; delegationAllowed: boolean }) => {
        if (singleRole.delegationAllowed) {
          roleArray.push({
            role: singleRole.roleName,
            delegationAllowed: singleRole.delegationAllowed,
          });
        }
      }
    );
    return roleArray;
  };

  const roleArray: any[] = createRoleArray();

  const onRoleSelect = (role: any) => {
    modifySelectedRole(role);
    changeLocation(DELEGATION_MANAGEMENT_URLS.USER_CHOICE);
  };

  return (
    <React.Fragment>
      <div className={classes["actionsTop"]}>
        <OutlinedButton onClick={() => changeLocation(ROUTES.DELEGATES)}>
          <FormattedMessage {...messages.backCTA} />
        </OutlinedButton>
        <OutlinedButton
          disabled={!selectedRole.role}
          onClick={() => changeLocation(DELEGATION_MANAGEMENT_URLS.USER_CHOICE)}
        >
          <FormattedMessage {...messages.continueCTA} />
        </OutlinedButton>
      </div>
      <div className={classes["mainTitle"]}>
        <FormattedMessage {...messages.mainTitle} />
      </div>
      {userInfo && (
        <div className={classes["rolesListClass"]}>
          {roleArray.length > 0 && (
            <RolesList
              roles={roleArray}
              onClick={onRoleSelect}
              selected={selectedRole}
            />
          )}
          {roleArray.length === 0 && (
            <div className={classes.emptyRoles}>
              <FormattedMessage {...messages.emptyRoles} />
            </div>
          )}
        </div>
      )}
      <div className={classes["actions"]}>
        <OutlinedButton onClick={() => changeLocation(ROUTES.DELEGATES)}>
          <FormattedMessage {...messages.backCTA} />
        </OutlinedButton>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps: any = () =>
  createStructuredSelector({
    userInfo: selectUserInfo,
    selectedRole: selectSelectedRole,
  });

const mapDispatchToProps: any = {
  modifySelectedUsersDelegation: (users: any[]) =>
    modifySelectedUsersDelegation(users),
  modifySelectedRole: (selectedRole: {}) => modifySelectedRole(selectedRole),
  changeLocation: (url: string) => push(url),
};

const withConnect: any = connect(mapStateToProps, mapDispatchToProps);

export default withConnect(DelegationManagementStepTwo);
